import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';

class CropModal extends Component {
  constructor(props) {
    super(props);
    const aspectRatio = this.props.aspectRatio || (1280 / 700);
    this.state = {
      crop: {
        aspect: aspectRatio,
        x: 0,
        y: 0,
        width: 100
      },
      imgLoaded: false,
      submitted: false,
      pixelCrop: {
        width: 1280,
        height: 700,
        x: 0,
        y: 0
      }
    };
    this.setCrop = this.setCrop.bind(this);
    this.setPixelCrop = this.setPixelCrop.bind(this);
    this.submitCrop = this.submitCrop.bind(this);
  }

  setPixelCrop(crop, img, pixelCrop) {
    if (!pixelCrop) {
      this.setState({ imgLoaded: true });
      return;
    }
    this.setState({ pixelCrop, imgLoaded: true });
  }

  setCrop(crop, pixelCrop) {
    this.setState({ crop, pixelCrop });
  }

  submitCrop() {
    const { onCropSelect } = this.props;
    const { pixelCrop } = this.state;
    this.setState({ submitted: true });
    onCropSelect(pixelCrop);
  }

  render() {
    const { imageUrl, minimal, subcopy } = this.props;
    const { imgLoaded, crop, submitted } = this.state;

    return (
      <div id={minimal ? 'cropper' : 'crop-modal'}>
        {!minimal && (
          <div className="modal-header">
            <h3 className="modal-title">Crop Photo</h3>
            {subcopy && (
              <p className="margin-top">{subcopy}</p>
            )}
          </div>
        )
        }
        <div className={minimal ? 'cropper' : 'modal-body'}>
          <div className="crop-wrapper">
            <ReactCrop src={imageUrl} onComplete={this.setCrop} onImageLoaded={this.setPixelCrop} crop={crop} keepSelection onChange={this.setCrop} />
          </div>
          <div className="save-crop">
            <button type="button" className="btn btn-primary btn-wide" onClick={this.submitCrop} disabled={submitted || !imgLoaded}>{submitted ? 'Uploading...' : 'Crop Image'}</button>
          </div>
        </div>
      </div>
    );
  }
}

CropModal.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onCropSelect: PropTypes.func.isRequired,
  aspectRatio: PropTypes.number,
  minimal: PropTypes.bool,
  subcopy: PropTypes.string
};

export default CropModal;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/CropModal.jsx